<template>
  <b-container fluid style="max-width:1200px;">
    <b-card bg-variant="light" class="mt-3">
      <b-row>
        <b-col>
          <ulu-logo :brand="brand" />
        </b-col>
        <b-col>
          <b-btn
            v-if="
              !edit &&
                permissions !== null &&
                getUserBrandPermissions.permissions_edit
            "
            @click="edit = true"
            variant="info"
            class="float-right m-2"
          >
            {{ $t("globals.edit") }}
          </b-btn>
          <b-btn
            v-if="
              permissions === null && getUserBrandPermissions.permissions_edit
            "
            variant="info"
            @click="enable"
            class="float-right m-2"
          >
            {{ $t("globals.enable") }}
          </b-btn>
          <b-btn
            v-if="edit"
            @click="save"
            variant="success"
            class="float-right m-2"
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            v-if="edit"
            @click="cancel"
            variant="warning"
            class="float-right m-2"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
          <b-btn
            v-if="edit && !newPerm && getUserBrandPermissions.permissions_edit"
            @click="disable"
            variant="danger"
            class="float-right m-2"
          >
            {{ $t("globals.disable") }}
          </b-btn>
          <b-btn
            v-if="edit"
            @click="assignAll"
            variant="info"
            class="float-right m-2"
          >
            {{ "Check all" }}
          </b-btn>
        </b-col>
      </b-row>
      <b-row v-if="permissions !== null">
        <b-col>
          <b-card-group deck>
            <!-- Inquiries -->
            <b-card class="permissions-card">
              <h5 class="text-info">{{ $t("globals.inquiries") }}:</h5>
              <b-form-checkbox
                v-model="permissions.inquiries_index"
                
                switch
                :disabled="!edit"
              >
                Index
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.inquiry_show"
                
                switch
                :disabled="!edit"
              >
                Show
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.inquiry_create"
                
                switch
                :disabled="!edit"
              >
                Create
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.inquiry_create_master"
                
                switch
                :disabled="!edit"
              >
                Create master (change agent)
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.inquiry_edit_price"
                
                switch
                :disabled="!edit"
              >
                Edit prices on new inquiry
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.inquiry_hard_delete"
                
                switch
                :disabled="!edit"
              >
                Inquiry hard delete
              </b-form-checkbox>
            </b-card>
            <!-- Orders -->
            <b-card class="permissions-card">
              <h5 class="text-info">{{ $t("globals.orders") }}:</h5>
              <b-form-checkbox
                v-model="permissions.orders_index"
                
                switch
                :disabled="!edit"
              >
                Index
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_show"
                
                switch
                :disabled="!edit"
              >
                Show
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_create"
                
                switch
                :disabled="!edit"
              >
                Create
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_complete"
                
                switch
                :disabled="!edit"
              >
                Complete
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_terminate"
                
                switch
                :disabled="!edit"
              >
                Terminate
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_cancel"
                
                switch
                :disabled="!edit"
              >
                Cancel
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_add_connectivity"
                
                switch
                :disabled="!edit"
              >
                Add connectivity
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_item_quantity_edit"
                
                switch
                :disabled="!edit"
              >
                Edit item quantity
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_add_device"
                
                switch
                :disabled="!edit"
              >
                Add a device
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_add_item"
                
                switch
                :disabled="!edit"
              >
                Add a item
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_uncomplete_delete"
                
                switch
                :disabled="!edit"
              >
                Delete uncompleted order
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_item_price_edit"
                
                switch
                :disabled="!edit"
              >
                Order item price edit
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_note_edit"
                
                switch
                :disabled="!edit"
              >
                Order note edit
              </b-form-checkbox>
            </b-card>
            <!-- Order services -->
            <b-card class="permissions-card">
              <h5 class="text-info">{{ $t("globals.order_services") }}:</h5>
              <b-form-checkbox
                v-model="permissions.order_service_index"
                
                switch
                :disabled="!edit"
              >
                Index
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_service_tab"
                
                switch
                :disabled="!edit"
              >
                Service tab
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_service_create_replace"
                
                switch
                :disabled="!edit"
              >
                Create replace
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_service_create_install"
                
                switch
                :disabled="!edit"
              >
                Create install
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_service_create_remove"
                
                switch
                :disabled="!edit"
              >
                Create remove
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_service_edit_request_replace"
                
                switch
                :disabled="!edit"
              >
                Edit/Request replace
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_service_edit_request_install"
                
                switch
                :disabled="!edit"
              >
                Edit/Request install
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.order_service_edit_request_remove"
                
                switch
                :disabled="!edit"
              >
                Edit/Request remove
              </b-form-checkbox>
            </b-card>
            <!-- Invoices -->
            <b-card class="permissions-card">
              <h5 class="text-info">{{ $t("globals.invoices") }}:</h5>
              <b-form-checkbox
                v-model="permissions.invoices_index"
                
                switch
                :disabled="!edit"
              >
                Index
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.invoice_pause"
                
                switch
                :disabled="!edit"
              >
                Pause
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.invoice_resume"
                
                switch
                :disabled="!edit"
              >
                Resume
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.invoice_paid"
                
                switch
                :disabled="!edit"
              >
                Paid
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.invoice_exact_import"
                
                switch
                :disabled="!edit"
              >
                Exact import
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.invoice_exact_export"
                
                switch
                :disabled="!edit"
              >
                Exact export
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.invoice_resend"
                
                switch
                :disabled="!edit"
              >
                Resend
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.invoice_edit_note"
                
                switch
                :disabled="!edit"
              >
                Edit notes
              </b-form-checkbox>
            </b-card>
            <!-- Devices -->
            <b-card class="permissions-card">
              <h5 class="text-info">{{ $t("globals.devices") }}:</h5>
              <b-form-checkbox
                v-model="permissions.devices_index"
                switch
                :disabled="!edit"
              >
                Index
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.device_actions"
                switch
                :disabled="!edit"
              >
                Actions
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.device_transfer"
                switch :disabled="!edit"
              >
                Transfer
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.create_device_event"
                switch :disabled="!edit"
              >
                Create event
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.create_device_event_custom_agent"
                switch :disabled="!edit"
              >
                Custom agent on event
              </b-form-checkbox>
            </b-card>
            <!-- Synatec -->
            <b-card class="permissions-card">
              <h5 class="text-info">Synatec:</h5>
              <b-form-checkbox
                v-model="permissions.synatec_orders_index"
                switch :disabled="!edit"
              >
                Synatec orders index
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.synatec_order_create"
                switch :disabled="!edit"
              >
                Synatec order create
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.synatec_order_edit"
                switch :disabled="!edit"
              >
                Synatec order edit
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.synatec_order_request"
                switch :disabled="!edit"
              >
                Synatec order request
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.manage_synatec_products"
                switch :disabled="!edit"
              >
                Manage Synatec products
              </b-form-checkbox>
            </b-card>
            <!-- Customers -->
            <b-card class="permissions-card">
              <h5 class="text-info">{{ $t("globals.customer") }}:</h5>
              <b-form-checkbox
                v-model="permissions.customers_index"
                
                switch
                :disabled="!edit"
              >
                Index
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.customer_show"
                
                switch
                :disabled="!edit"
              >
                Show
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.customer_create"
                
                switch
                :disabled="!edit"
              >
                Create
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.customer_block_streatus"
                
                switch
                :disabled="!edit"
              >
                Block streatus
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.customer_set_web_app_id"
                switch :disabled="!edit"
              >
                Set web app id
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.customers_merge"
                switch :disabled="!edit"
              >
                Merge
              </b-form-checkbox>
            </b-card>
            <!-- Price List -->
            <b-card class="permissions-card">
              <h5 class="text-info">{{ $t("globals.price_list") }}:</h5>
              <b-form-checkbox
                v-model="permissions.price_list_index"
                
                switch
                :disabled="!edit"
              >
                Index
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.price_list_show"
                
                switch
                :disabled="!edit"
              >
                Show
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.price_list_edit"
                
                switch
                :disabled="!edit"
              >
                Edit
              </b-form-checkbox>
            </b-card>
            <!-- Permissions -->
            <b-card class="permissions-card">
              <h5 class="text-info">{{ $t("globals.permissions") }}:</h5>
              <b-form-checkbox
                v-model="permissions.permissions_index"
                
                switch
                :disabled="!edit"
              >
                Index
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.permissions_show"
                
                switch
                :disabled="!edit"
              >
                Show
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.permissions_edit"
                
                switch
                :disabled="!edit"
              >
                Edit
              </b-form-checkbox>
            </b-card>
            <!-- KPIS -->
            <b-card class="permissions-card">
              <h5 class="text-info">KPI's:</h5>
              <b-form-checkbox
                v-model="permissions.kpi_devices"
                
                switch
                :disabled="!edit"
              >
                Devices
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.kpi_finance"
                
                switch
                :disabled="!edit"
              >
                Finance
              </b-form-checkbox>
            </b-card>
            <!-- Other -->
            <b-card class="permissions-card">
              <h5 class="text-info">Other:</h5>
              <b-form-checkbox
                v-model="permissions.super_admin"
                
                switch
                :disabled="!edit"
              >
                Super admin
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.credit_create"
                switch
                :disabled="!edit"
              >
                Create credit
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.import_tool"
                :disabled="!edit" switch
              >
                Import tool
              </b-form-checkbox>
            </b-card>
            <!-- Installations -->
            <b-card class="permissions-card">
              <h5 class="text-info">{{ $t("globals.installations") }}:</h5>
              <b-form-checkbox
                v-model="permissions.installations_index"
                switch :disabled="!edit"
              >
                Index
              </b-form-checkbox>
              <b-form-checkbox
                v-model="permissions.installation_request"
                switch :disabled="!edit"
              >
                Installation request
              </b-form-checkbox>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Permissions from "@/models/permissions/Permissions";

export default {
  components: {
    "ulu-logo": () => import("@/components/common/Logo.vue")
  },
  props: {
    permissions: Object,
    reloadUser: Function,
    updatePermissions: Function,
    brand: String
  },
  data() {
    return {
      edit: false,
      newPerm: false
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    ...mapMutations(["setShowLoadingModal"]),
    cancel() {
      this.permissions = null;
      this.reloadUser();
      this.edit = false;
      this.newPerm = false;
    },
    enable() {
      this.edit = true;
      this.newPerm = true;
      this.permissions = new Permissions(this.brand);
    },
    disable() {
      let data = {
        query: `
          mutation {
            res: BrandPermissionDelete (
              id: ${parseInt(this.permissions.id)}
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancel();
      });
    },
    save() {
      if (this.newPerm) {
        this.saveNew();
      } else {
        this.saveUpdated();
      }

      this.edit = false;
      this.newPerm = false;
      //this.reloadUser();
    },
    assignAll() {
      for (const [key, value] of Object.entries(this.permissions)) {
        if (key !== "id" && key !== "brand")
        this.permissions[key] = true;
      }
    },
    saveNew() {
      this.setShowLoadingModal(true);

      let newPermissions = JSON.parse(JSON.stringify(this.permissions));
      newPermissions.id = 0;

      let data = {
        query: `
          mutation BrandPermissionCreate ($user_id: Int, $permissions: BrandPermissionInput) {
            res: BrandPermissionCreate (user_id: $user_id, permissions: $permissions)
          }
        `,
        variables: {
          user_id: parseInt(this.$route.params.id),
          permissions: newPermissions
        }
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancel();
      });
    },
    saveUpdated() {
      this.setShowLoadingModal(true);

      let editedPermissions = JSON.parse(JSON.stringify(this.permissions));

      let data = {
        query: `
          mutation BrandPermissionUpdate ($permissions: BrandPermissionInput) {
            res: BrandPermissionUpdate (permissions: $permissions)
          }
        `,
        variables: {
          permissions: editedPermissions
        }
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancel();
      });
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"])
  },
  watch: {
    permissions: function() {
      this.updatePermissions(this.permissions);
    }
  }
};
</script>

<style scoped>
.permissions-card {
  min-width: 230px;
  margin-top: 10px;
}

.logo {
  height: 2.5em;
  margin-bottom: 1em;
}
</style>
